import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import makerjs, { IPoint } from "makerjs";
import {isEmpty} from "lodash";
import OffsetLine from "../Lines/OffsetLine";

export class Heart extends AbstractShape {

	constructor( dimensions?: object ) {
		super( 'heart', dimensions );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		const a = this.getLength().in_cm() / (
			3 / 4 * Math.sqrt( 2 ) + 1 / 2
		);

		const heartWidth = a * (
			Math.sqrt( 2 ) / 2 + 1
		);

		return Length.from_cm( heartWidth );
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, this.getDimensionLineType('measurements-heart-height', focusedElement, forceRender) ), // Vertical line
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width', this.getWidth().in_cm() ), [0, -40], ratio ), // Horizontal line
			];
		}

		return [];
	}

	/**
	 * Creates a model instance of the shape.
	 */
	createModel(): void {
		if ( isEmpty( this.cleanedPrimitives ) ) {
			return;
		}

		super.createModel();

		makerjs.model.zero( this.model );
		makerjs.model.originate( this.model );
	}

	getDefaultDimensions(): Dimensions {
		return { height: 20 };
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const height = enclosingRectangle.height();

		return {
			height: height.divide(4).in_cm(),
		};
	}
}
